if (window.Sentry) {
  Sentry.init({ dsn: "https://88d7623b3cce44eba015174692293607@o239071.ingest.sentry.io/5355496" });
}
